import { Grid, Stack, Typography } from "@mui/material";
import useAuthStore from "../../stores/useAuthStore";
import UpcomingReservations from "../../components/displays/reservations/UpcomingReservations";

export default function Home() {
  const { organization } = useAuthStore();
  return (
    <Stack>
      <Stack mb={2}>
        <Typography variant="h4"><b>{organization.name}</b> Dashboard</Typography>
      </Stack>
      <Stack>
        <Grid container spacing={2}>
          <Grid item sm={4}>
            <UpcomingReservations />
          </Grid>
        </Grid>
      </Stack>
    </Stack>
  );
}